import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { BienMueble } from "../../models/trust/empleado/BienMueble";
import { OtroBienMuebleService } from "../../service/trust/empleado/OtroBienMuebleService";

export const OtroBienMueble = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new BienMueble();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const otroBienSrv = new OtroBienMuebleService();
    const tablaBienMueble = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inDrop, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaBienMueble.lazyParams, id]);

    const loadLazyData = () => {
        tablaBienMueble.setLoading(true);
        const _params = { ...tablaBienMueble.lazyParams, idp: id };
        otroBienSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaBienMueble.setTotalRecords(res.data.total);
            tablaBienMueble.setData(res.data.registros);
        }).finally(() => tablaBienMueble.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;

        const request = getValues('id') == null
            ? otroBienSrv.nuevo(data)
            : otroBienSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        otroBienSrv.consultar(idReg).then(res => {
            reset(generic.renewValues(res.data.otro_bien_mueble, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este bien mueble?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                otroBienSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_bien_mueble" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Otros Bienes Muebles
            </span>
        </div>
    );

    return (
        <div className="componente-otro-bien-mueble">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_bien_mueble" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaBienMueble} datos={tablaBienMueble.data} totalRegistros={tablaBienMueble.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nuevo Bien Mueble" : "Editar Bien Mueble"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '520px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-box text-primary"></i>
                                    OTRO BIEN MUEBLE
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        {inDrop('tipo_bien_mueble', catalogos?.tipo_bien_mueble, { lab: omodel.optionLabel }, 6)}
                        {inNumber('valor_bien', 2, false, { prefix: '$ ' }, 6)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
